import { LOGIN_CONST } from '../constant/page-constants';

export const getLocalStorageCustom = (name) => {

    if (name) return localStorage.getItem(name);
    return null;
}

export const setLocalStorageCustom = (name, value) => {

    if (name && value) localStorage.setItem(name, value);
}

const isSecureContext = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    return window.location.protocol === 'https:' || window.location.hostname === 'localhost';
};

const getCookieAttributes = () => {
    const attributes = ['Path=/', 'SameSite=Strict'];

    if (isSecureContext()) {
        attributes.push('Secure');
    }

    return attributes.join('; ');
};

// HttpOnly cookies cannot be set from JavaScript; the backend should issue auth cookies with HttpOnly when possible.
export const setCookieCustom = (name, value, expires) => {
    const expiry = expires ? `expires=${expires}; ` : '';
    document.cookie = `${name}=${value}; ${expiry}${getCookieAttributes()}`;
}

export const getCookieCustom = (name) => {
    try {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    } catch (err) {
        return null;
    }
}

export const deleteCookieCustom = (name) => {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; ${getCookieAttributes()}`;
}

export const clearAuthSession = () => {
    deleteCookieCustom(LOGIN_CONST.ACCESS_TOKEN);
    deleteCookieCustom(LOGIN_CONST.REFRESH_TOKEN);
}
